import { render } from "./BlockedChannels.vue?vue&type=template&id=75373402"
import script from "./BlockedChannels.vue?vue&type=script&lang=js"
export * from "./BlockedChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__